import React, { useEffect, useState, useContext } from 'react'
import './single.scss'
import Sidebar from '../../../components/sidebar/Sidebar'
import Navbar from '../../../components/navbar/Navbar'
// import Chart from '../../../components/chart/Chart'
import { doc, getDoc, onSnapshot, collection, query, where, getDocs, updateDoc } from "firebase/firestore"
import {  Link, useParams } from "react-router-dom"
import { db } from '../../../firebase'
import Switch from '@mui/material/Switch';
import img from '../../../assets/images/user.png'
import ConfirmStatusBox from '../../../components/ConfirmStatusBox'
import Typography from '@mui/material/Typography';
import Breadcrumbs from '@mui/material/Breadcrumbs';
// import UserOrderTable from '../../../components/table/Use
import ConfirmBox from '../../../components/ConfirmBox';
import commentorPhoto from '../../../assets/images/user.png'

import outlet from '../../../assets/images/outlet-2.png'

import { AuthContext } from '../../../context/AuthContext'


const Single = ({user}) => {

  const {coinId} = useParams()

  const [isloading, setIsloading ] = useState(false)
  
  const [ pointData, setPointData ] = useState("")

  const [ openModal, setOpenModal ] = useState(false)

  const closeModal = () => setOpenModal(false)

  const [openStatus, setOpenStatus] = useState(false)

  const { currentUser } = useContext(AuthContext)
        
  const userIds = currentUser.uid;


      
  const [adminRole, setAdminRole] = useState("")


      
  const getAdminRole = async() => {
    
    const docRef = doc(db, "admins", userIds);

    const docSnap = await getDoc(docRef);

    
    if (docSnap.exists()) {

      setAdminRole(docSnap.data().role)

    } else {

      console.log("No such document!");
    }
  }


  useEffect(()=>  {

    getAdminRole()

  }, [])
    


  useEffect(() => {

    const docRef = doc(db, "pointcenter", coinId);

    const unsubscribe = onSnapshot(docRef, (docSnap) => {

      if (docSnap.exists()) {

        setPointData({ id: docSnap.id, ...docSnap.data() });

      } else {
        
        setPointData(null);

      }

    }, (error) => {

      console.error("Error listening to document:", error);

    });

    return () => unsubscribe();

  }, [coinId]);





  const options = {  maximumFractionDigits: 2 }


  const Modal = ({open, close, photo}) => {
     
    if(!open) return null
    return(
     <div style={{
      backgroundColor: 'black',
      widows:'100%',
      height:'100%',
     }}>
       <div style={{

        maxWidth: 600,
        backgroundColor: 'white',
      }}>
       
         <div className="modalRight">
           <p className="closeBtn" onClick={close}>X</p>
           <div></div>

 
         </div>
       </div>
     </div>
    )
}


     const handleStatus = async() => {
    
        
        const pointRef = doc(db, "pointcenter", coinId);
    
        await updateDoc(pointRef, {
    
        status: pointData.status === "active" ? 'inactive' : 'active', 
        
     })
    
      setOpenStatus(false)
    
      }
 

  return (
    <div className='single'>

      <Modal open={openModal} close={closeModal} />

      <Sidebar/>
      <div className='singleContainer'>
        <Navbar/>
          <div className='topContainer'>
            <div className='topLeft'><h1>Single Point</h1></div>
            
            <div className='topRight'>
            <Breadcrumbs aria-label="breadcrumb">
              <a underline="hover" color="inherit" href="/">
                Home
              </a>
              <a
                underline="hover"
                color="inherit"
                href="/coin"
              >
                Loyalty Point List
              </a>
              <Typography color="green">Single Point</Typography>
            </Breadcrumbs>
            </div>
          </div>
        <div className="top">
          <div className="left">
            {/* <div className="editbutton">Edit</div> */}
            <div style={{display: 'flex', flexDirection:'row', alignItems:'center', justifyContent:'space-between'}}>
            <h2 style={{marginLeft:20, marginTop:20, marginBottom:20, color:'#666'}}>{pointData.title} Point Information</h2>

            {
              adminRole === "adminAccess"

              ?

                <div style={{display:'flex', flexDirection:'row', gap:10, justifyContent:'center', alignItems:'center', marginRight:100 }}>
                <a onClick={(event)=> {event.preventDefault(); setOpenStatus(true);}}  style={{ border: '1px solid green', borderRadius:'5px', justifyItems:'center', alignItems:'center', textDecoration:'none', paddingTop:'10px', paddingBottom:'10px', paddingRight:'40px', paddingLeft:'40px', backgroundColor:pointData.status === "active" ? "green" : "red", cursor:'pointer'}}>
                    <span style={{color:'white', fontWeight:'bold'}}>{pointData.status === "active" ? "Active" : "Inactive"}</span>
                </a>

                 <Link to={`/coin/edit/${coinId}`} style={{ border: '1px solid blue', borderRadius:'5px', justifyItems:'center', alignItems:'center', textDecoration:'none', paddingTop:'10px', paddingBottom:'10px', paddingRight:'40px', paddingLeft:'40px', backgroundColor:"blue", cursor:'pointer'}}>
                    <span style={{color:'white', fontWeight:'bold'}}>Edit</span>
                </Link>

      

            </div>

            :

            adminRole === "subadminAccess"

            ?

              <div style={{display:'flex', flexDirection:'row', gap:10, justifyContent:'center', alignItems:'center', marginRight:100 }}>
                <a onClick={(event)=> {event.preventDefault(); setOpenStatus(true);}}  style={{ border: '1px solid green', borderRadius:'5px', justifyItems:'center', alignItems:'center', textDecoration:'none', paddingTop:'10px', paddingBottom:'10px', paddingRight:'40px', paddingLeft:'40px', backgroundColor:pointData.status === "active" ? "green" : "red", cursor:'pointer'}}>
                    <span style={{color:'white', fontWeight:'bold'}}>{pointData.status === "active" ? "Active" : "Inactive"}</span>
                </a>

                 <Link to={`/coin/edit/${coinId}`} style={{ border: '1px solid blue', borderRadius:'5px', justifyItems:'center', alignItems:'center', textDecoration:'none', paddingTop:'10px', paddingBottom:'10px', paddingRight:'40px', paddingLeft:'40px', backgroundColor:"blue", cursor:'pointer'}}>
                    <span style={{color:'white', fontWeight:'bold'}}>Edit</span>
                </Link>

      

            </div>

            :

            ""



            }


            </div>
            <div className='item'>
              
                <div className="details">
               
                  <div className='detailItem'>
                    <span className='itemKey'>Like Pint:</span>
                    <span className='itemValue'>{pointData.like}</span>
                  </div>
                  <div className='detailItem' style={{width:420}}>
                    <span className='itemKey'>Invite Friend Point:</span>
                    <span className='itemValue'>{pointData.invitefriend}</span>
                  </div>
                   <div className='detailItem' style={{width:420}}>
                    <span className='itemKey'>Invite Outlet Point:</span>
                    <span className='itemValue'>{pointData.inviteOutlet}</span>
                  </div>
                  <div className='detailItem'>
                    <span className='itemKey'>Date Created:</span>
                    <span className='itemValue'>{pointData.createdAt}</span>
                  </div>
                  <div className='detailItem'>
                    <span className='itemKey'>Status:</span>
                    <span className='itemValue'>{pointData.status}</span>
                  </div>
                </div>



            </div>
          </div>
          
        </div>
        
        <ConfirmStatusBox
          openStatus={openStatus}
          closeDialog={() => setOpenStatus(false)}
          statusFunction={handleStatus }
        />



      </div>
    </div>
  )
}

export default Single